import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Loader from './utils/Loader';
import { getLoggedUser, updateLoggedUser } from '../api';

const UserAccount = ({ accessToken }) => {
  const [error, setError] = useState(null);
  // const [user, setUser] = useState(null);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [passwordNew, setPasswordNew] = useState('');
  const [passwordCheck, setPasswordCheck] = useState('');

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await getLoggedUser(accessToken);

        if (res) {
          // setUser(res.data);

          setUsername(res.data.email);
        } else {
          console.error('Error fetching user data');

          setError('Nepodařilo se získat data o uživateli');
        }
      } catch (err) {
        console.error('Fetch user error', err);

        setError(err.response.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();
  }, [accessToken]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (passwordNew !== passwordCheck) {
      setError('Hesla se neshodují');

      return;
    }

    try {
      setIsLoading(true);

      await updateLoggedUser(accessToken, password, passwordNew);
    } catch (err) {
      console.error(err);

      setIsLoading(false);
      setError(err.response.message);
    } finally {
      navigate('/user/account');

      setIsLoading(false);
    }
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handlePasswordNewChange = (event) => {
    setPasswordNew(event.target.value);
  };

  const handlePasswordCheckChange = (event) => {
    setPasswordCheck(event.target.value);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h5">
          Můj účet
        </Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            fullWidth
            name="username"
            label="Přihlašovací jméno"
            id="username"
            value={username}
            disabled={true}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Staré heslo"
            type="password"
            id="password"
            value={password}
            autoComplete="current-password"
            onChange={handlePasswordChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password_new"
            label="Nové heslo"
            type="password"
            id="password-new"
            value={passwordNew}
            error={error !== null}
            helperText={error !== null ? error : ''}
            autoComplete="new-password"
            onChange={handlePasswordNewChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password_check"
            label="Nové heslo znovu"
            type="password"
            id="password-check"
            value={passwordCheck}
            error={error !== null}
            helperText={error !== null ? error : ''}
            autoComplete="check-password"
            onChange={handlePasswordCheckChange}
          />
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
            Uložit
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default UserAccount;
